import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutletComponent, WrapperComponent } from '@shared/ui/components';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';

import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';
import { BreadcrumbsModule, BreadcrumbsService } from '@shared/modules/page-settings';
import { UiComponentsModule } from '@shared/ui/components';
import { MenuItem } from 'primeng/api';
import { Breadcrumb } from 'primeng/breadcrumb';
import { filter, map } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterOutletComponent,
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    UiComponentsModule,
    BreadcrumbsModule,
    RouterModule,
    WrapperComponent,
  ],
  templateUrl: './without-reza-layout.component.html',
  styleUrl: './without-reza-layout.component.css',
})
export class WithoutRezaLayoutComponent implements OnInit {
  hideBreadcrumb = true;

  breadcrumbs$ = this.breadcrumbsService.breadcrumbs$.pipe(
    map((breadcrumbs: Breadcrumb[]) => {
      return [
        {
          icon: 'pi pi-home',
          routerLink: `/`,
          label: 'home',
        } as MenuItem,
        ...breadcrumbs,
      ];
    })
  );

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    @Inject(WINDOW) readonly windowRef: Window,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateRouteAttributes();
    });

    this.breadcrumbsService.init();
    this.updateRouteAttributes();
  }

  private updateRouteAttributes(): void {
    let route = this.activatedRoute.firstChild;
    while (route?.firstChild) {
      route = route.firstChild;
    }

    this.hideBreadcrumb = route?.snapshot.data['hideBreadcrumb'] === true;
  }
}
